import React from "react";
import Swal from "sweetalert2";

export const ErrorAlert = ({ show, text }) => {
  React.useEffect(() => {
    if (show) {
      Swal.fire({
        icon: "error",
        title: "Hoppá! Valami hiba történt!",
        text,
        confirmButtonColor: "#b14",
        didOpen: () => {
          const modalContainer = Swal.getContainer();
          if (modalContainer) {
            modalContainer.style.zIndex = "999";
          }
        }
      });
    }
  }, [show, text]);

  return null;
};

export const showErrorAlert = async ({ title, text }) => {
  Swal.fire({
    title,
    text,
    icon: "error",
    confirmButtonColor: "#b14",
    didOpen: () => {
      const modalContainer = Swal.getContainer();
      if (modalContainer) {
        modalContainer.style.zIndex = "999";
      }
    }
  });
};

export const showSuccessAlert = async ({ title }) => {
  Swal.fire({
    title,
    icon: "success",
    confirmButtonColor: "#114ab6",
    didOpen: () => {
      const modalContainer = Swal.getContainer();
      if (modalContainer) {
        modalContainer.style.zIndex = "9999";
      }
    }
  });
};

export const showConfirmAlert = async ({ title, text }) => {
  const result = await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Igen",
    cancelButtonText: "Nem",
    confirmButtonColor: "#28a745",
    cancelButtonColor: "#dc3545",
    didOpen: () => {
      const modalContainer = Swal.getContainer();
      if (modalContainer) {
        modalContainer.style.zIndex = "9999";
      }
    }
  });

  return result.isConfirmed;
};

export default ErrorAlert;
